import EnhancedContact from './EnhancedContact';

export default function Contact() {
  return <EnhancedContact />;
}
